import React from 'react';
interface FilterChipProps {
  label: string;
  active?: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
}
export function FilterChip({
  label,
  active = false,
  onClick,
  icon
}: FilterChipProps) {
  return <button type="button" onClick={onClick} aria-pressed={active} className={`flex min-h-[38px] items-center gap-1 whitespace-nowrap rounded-pill border px-2 text-[12.5px] font-medium transition-[background-color,border-color,color] duration-150 ease-brand ${active ? 'border-deep bg-deep text-sand' : 'border-sand-line bg-white/70 text-deep hover:border-deep/30'}`} data-id="element-646" data-mp="38uauqx7lhyiu">
      {icon}
      {label}
    </button>;
}